import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { C, t } from '../Dashboard/components/dashboardConstants';
import TalentContentContainer from '../layout/TalentContentContainer';
import ApplicationsSearchBar from './components/ApplicationsSearchBar';
import ApplicationCard from './components/ApplicationCard';
import { getMyApplications } from '../../../api';
import { STATUS_MAP } from './utils';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

function formatDate(isoStr) {
  if (!isoStr) return '-';
  return isoStr.slice(0, 10).replace(/-/g, '. ');
}

function mapApplication(item) {
  const lastUpdatedRaw = item.statusChangedAt ?? item.submittedAt ?? null;
  return {
    id: item.id,
    castingPostId: item.castingPostId,
    title: item.castingPostTitle || '',
    status: STATUS_MAP[item.status] || item.status,
    company: item.companyName || '',
    role: item.roleName || '',
    date: formatDate(item.submittedAt),
    updatedAgo: formatDate(lastUpdatedRaw),
  };
}

export default function TalentApplicationsPage() {
  const navigate = useNavigate();
  const [applications, setApplications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('전체');
  const [filterOpen, setFilterOpen] = useState(false);

  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      setIsError(false);
      try {
        const res = await getMyApplications();
        const list = Array.isArray(res) ? res : (res?.content ?? []);
        setApplications(list.map(mapApplication));
      } catch {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, []);

  const filtered = applications.filter(app => {
    const matchFilter = filter === '전체' || app.status === filter;
    const matchSearch = app.title.includes(search) || app.company.includes(search) || app.role.includes(search);
    return matchFilter && matchSearch;
  });

  return (
    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      <TalentContentContainer>
        {/* 헤더 */}
        <div style={{ padding: '50px 40px 0', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '40px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <h1 style={{ ...t('36px', 600, C.bk), margin: 0 }}>지원 현황</h1>
            <p style={{ ...t('16px', 400, C.sub), margin: 0 }}>지원한 공고 및 캐스팅의 현황을 확인하세요.</p>
          </div>
          {/* <div
            style={{ position: 'relative', cursor: 'pointer', background: C.white, border: `1px solid ${C.g200}`, borderRadius: '12px', padding: '12px', boxShadow: C.shadow }}
            onClick={() => navigate('/talent/messages')}
          >
            <IcoChat c={C.bk} />
            <div style={{ position: 'absolute', top: '-6px', right: '-6px', width: '20px', height: '20px', borderRadius: '50%', background: C.point, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: C.bk, fontSize: '11px', fontWeight: 700, fontFamily: ff }}>2</span>
            </div>
          </div> */}
        </div>

        {/* 검색 + 필터 */}
        <div style={{ padding: '0 40px 20px' }}>
          <ApplicationsSearchBar
            search={search} setSearch={setSearch}
            filter={filter} setFilter={setFilter}
            filterOpen={filterOpen} setFilterOpen={setFilterOpen}
          />
        </div>

        {/* 결과 수 */}
        <div style={{ padding: '0 40px 12px' }}>
          <span style={t('14px', 400, C.sub)}>총 {filtered.length}건</span>
        </div>

        {/* 지원 목록 */}
        <div style={{ padding: '0 40px 80px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '80px 0', display: 'flex', justifyContent: 'center' }}><LoadingSpinner size="lg" /></div>
          ) : isError ? (
            <div style={{ ...t('16px', 400, C.sub), textAlign: 'center', padding: '80px 0' }}>데이터를 불러오지 못했습니다.</div>
          ) : filtered.length === 0 ? (
            <div style={{ ...t('16px', 400, C.sub), textAlign: 'center', padding: '80px 0' }}>
              검색 결과가 없습니다.
            </div>
          ) : (
            filtered.map(app => <ApplicationCard key={app.id} app={app} />)
          )}
        </div>
      </TalentContentContainer>
    </div>
  );
}
